import { render, staticRenderFns } from "./TemplateForm.vue?vue&type=template&id=1a067998&scoped=true&"
import script from "./TemplateForm.vue?vue&type=script&lang=js&"
export * from "./TemplateForm.vue?vue&type=script&lang=js&"
import style0 from "./TemplateForm.vue?vue&type=style&index=0&id=1a067998&prod&scoped=true&lang=css&"
import style1 from "./TemplateForm.vue?vue&type=style&index=1&id=1a067998&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a067998",
  null
  
)

export default component.exports